
import React from 'react';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import LoginForm from '../../common/client/components/LoginForm';
import Text from '../../common/client/components/Text';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';
import useAuthIsLogged from '../../common/client/hooks/mysliveckyportal/useAuthIsLogged';

import useNavigationItems  from '../../hooks/useNavigationItems';
import AuthLink from './AuthLink';
import AuthLinks from './AuthLinks';

const classNames = mergeStyleSets({
    LoginPage: {
    },
    panel: {
        backgroundColor: '#ffffff',
        marginTop: '128px',
        marginBottom: '128px',
        padding: '8px',
        border: '1px solid #999999',
        width: 430
    },
});

const Content = ({logged}) => {
    const history = useHistory();

    if (logged) {
        return <Redirect to="/" />;
    }

    const handleCancelClick = () => {
        history.push('/');
    }

    return (
        <LoginForm
            onCancelClick={handleCancelClick}
        />
    );
}

const LinkCreateAccount = () => {
    return (
        <AuthLink page="createAccount" title="Registrace nového uživatele" />
    );
}

const LinkForgottenPassword = () => {
    return (
        <AuthLink page="resetPassword" title="Obnovit zapomenuté heslo" />
    );
}

const LoginPage = () => {

    const logged = useAuthIsLogged();
    const navigationItems = useNavigationItems();

    return (
        <AppPageStyle
            navigationItems={navigationItems}
        >
            <Stack className={classNames.LoginPage}>
                <Stack.Item className={classNames.panel} align="center">
                    <Text xxLarge>Přihlášení</Text>
                    <Content
                        logged={logged}
                    />
                    <AuthLinks>
                        <LinkCreateAccount />
                        <LinkForgottenPassword />
                    </AuthLinks>
                </Stack.Item>
            </Stack>
        </AppPageStyle>
    );
}

export default LoginPage;
